import React from "react";
import {
	Box,
	Button,
	InputAdornment,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import InputLabelWizard from "../input-label-wizard.tsx";
import { Iconify } from "@onair/minimal-ui/iconify";
import TicketTierBox from "../ticket-tiers/ticket-tier-box.tsx";

interface PropTypes {
	prefixName: string;
}

const TicketTierForm: React.FC<PropTypes> = ({ prefixName }) => {
	const { control } = useFormContext();
	const {
		fields: ticketTierFields,
		append,
		remove,
	} = useFieldArray({
		control,
		name: prefixName,
		keyName: "_id",
	});

	return (
		<Stack spacing={2}>
			<Stack className="flex flex-row items-center justify-between">
				<InputLabelWizard>Thông tin loại vé</InputLabelWizard>

				<Button
					startIcon={<Iconify icon="mdi:plus" />}
					variant="text"
					color="primary"
					size="small"
					onClick={() => append({})}
				>
					Thêm loại vé
				</Button>
			</Stack>

			<Stack spacing={2}>
				{ticketTierFields.map((field, index) => (
					<Box
						sx={{
							border: "1px solid",
							borderColor: "divider",
						}}
						className="rounded-2xl p-4 bg-grey-100"
						key={field._id}
					>
						<TicketTierBox
							// @ts-ignore
							disableRemove={
								ticketTierFields.length === 1 || Boolean(field?.hasBeenPaid)
							}
							onDelete={() => remove(index)}
							prefixName={`${prefixName}.${index}`}
							key={field._id}
						/>
					</Box>
				))}
			</Stack>
		</Stack>
	);
};

export default TicketTierForm;
